import { Component, OnInit, ViewChild } from '@angular/core';
import { ApiService } from '../../../services/main/api.service';
import { NgbModal, ModalDismissReasons, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Storage } from '@ionic/storage';
import { Router, ActivatedRoute } from '@angular/router';
import { Global } from '../../../services/global';
import { BaseCrudComponent } from '../../base-crud/base-crud.component';
import { TranslateService } from '@ngx-translate/core';

import { Observable, from, of, concat } from 'rxjs';
import { mergeMap, catchError, timeout, retry } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';

const API_CONSULTAPLANTA = environment.API_CONSULTAPLANTA;
const API_REGISTROPLANTA = environment.API_REGISTROPLANTA;
const API_UPDATEPLANTA = environment.API_UPDATEPLANTA;
const API_DELETEPLANTA = environment.API_DELETEPLANTA;
const API_ACTIVARPLANTA = environment.API_ACTIVARPLANTA;
const API_USER_SYSTEM_GET_ALL = environment.Global.API_USER_SYSTEM_GET_ALL;
const API_USER_APPROVERS_GET_ALL_SIGNATURE = environment.Global.API_USER_APPROVERS_GET_ALL_SIGNATURE;



@Component({
  selector: 'app-paramplanta',
  templateUrl: './paramplanta.component.html',
  styleUrls: ['./paramplanta.component.css']
})
export class ParamplantaComponent extends BaseCrudComponent {

  id:any;
  loadingRequired = false;
  listAgr:any;
  translations:any;
  userinfo:any;
  curr_usr:any;
  listUsers:any = [];

  constructor(
    srv: ApiService,
        modalService: NgbModal,
        storage: Storage,
        router: Router,
        private route: ActivatedRoute,
        public translate: TranslateService
  ) {
    super(srv, modalService, storage, router);
        this.id = route.snapshot.params.id;

        this.read_url = API_CONSULTAPLANTA;
        this.create_url = API_REGISTROPLANTA;
        this.update_url = API_UPDATEPLANTA;
        this.delete_url = API_DELETEPLANTA;
        this.active_url = API_ACTIVARPLANTA;

        this.search_fields = ['Name', 'Direction', 'Description'];

        this.c_obj = [];
        this.u_obj = [];

        this.reload.subscribe(val => {
            if( val ){
                super.clearData();
                this.getList();
            }
        });
   }

  async ngOnInit() {
    await this.translate.getTranslation(this.translate.currentLang)
    .toPromise().then((translations) => {
          this.translations = translations;
          super.ngOnInit();
          this.getList();
    });
    this.userinfo = [];
    this.userinfo['name'] = '';
    this.userinfo['emailAddress'] = '';

    await this.storage.get('userinfo').then(x => {
        this.userinfo = x;
    });
  }

  public getList(){
    //debugger;
    var qst = this.read_url;
    this.loadingList = true;
    Swal.fire(
      {
        title: this.translations['loading'],
        html: '',
        icon: 'info',
      }
    );
    Swal.showLoading();
    this.srv.getCall(qst).subscribe(x => {
      //debugger;
      this.loadingList = false;

      if(x.success){
        if(x.val != null){
          this.rawdata = x.val;
          var rs = x.val;
          this.rows = rs;
          this.page = 1;
          if( Array.isArray(this.rows) ){
             this.pageTotal = this.rows.length;
          }
          this.filterAll();
          Swal.close()
        }else {
          Swal.fire(this.translations.empty, this.translations.not_registers, 'success');
          this.rows = [];
          return;
            }
      }else {
        Swal.fire(x.msg, '', 'error');
        return;
          }
  });
}

  public getUsersData(){
    var par_url = API_USER_APPROVERS_GET_ALL_SIGNATURE;

    return this.srv.getCall(par_url).pipe(
      mergeMap(data => {
        let mydata:any = {success: false, msg:'', val:[]};
        mydata = data;
        console.log(data);

        if(mydata.success == true ){
          return of(mydata.val);
        }
        else{
          return of(false);
        }
      }),
      //timeout(MAX_TIME),
      catchError(data => of(false))
    );
  }

  public addUser(obj: any) {
    console.log('addUser', obj);

    if (this.curr_usr === 0) return;

    let usrs = this.listUsers.filter(f => f.UserId == this.curr_usr);

    // Si no existe 'detail', inicialízalo como arreglo vacío
    if (!obj.detail) {
      obj.detail = [];
    }

    let checker = obj.detail.filter(f => f.UserId == this.curr_usr);

    if (usrs.length > 0 && checker.length === 0) {
      let usr = usrs[0];
      obj.detail.push({
        UserId: usr.UserId,
        labdResponsible: false,
        FullName: usr.FirstName + ' ' + usr.LastName
      });
    }
  }

  public createItem(content: any, form: any) {
    console.log('createItem', form);
    if (!form) {
      form = {};
    }

    const validated = this.validateCreateInfo(form);
    if (!validated) {
      Swal.fire(this.translations['msg_all_required'], '', 'error');
      return;
    }

    // Obtenemos el timestamp actual
    const now = new Date().toISOString();

    // Aprobadores deben estar cargados desde el objeto `u_obj.Aprobadores`
    // const aprobadores = this.u_obj.detail || [];
    const aprobadores = (this.u_obj.detail || []).map(u => u.labdUserId);

    // Armamos el objeto final
    const to = {
      PlantaID: form.PlantaID || 0, // o null si es creación
      Name: form.Name,
      Direction: form.Direction,
      CreatorUserId: this.userinfo['userId'],  // Asegúrate de que esto esté definido
      Status: form.Status || "A",
      CreationTime: now,
      Description: form.Description,
      LastModifierUserID: this.userinfo['userId'],  // También asegúrate de que esté definido
      LastModifierTime: now,
      Aprobadores: aprobadores
    };

    const qst = this.create_url;
    this.isCreating = true;

    this.srv.postCall(qst, to).subscribe(x => {
      this.isCreating = false;
      if (x.success) {
        this.getList();
        this.closeModal(content);
        Swal.fire('¡Creado!', x.msg, 'success');
      } else {
        Swal.fire(x.msg, '', 'error');
      }
    });
  }

  openCreateModal(content:any){
    this.c_obj['detail'] = [];
    this.curr_usr = 0;

    super.openCreateModal(content);
    this.loadingRequired = true;
    this.getUsersData().subscribe(x => {
      this.loadingRequired = false;
      if(x != false){
        this.listUsers = x;
      }
    });

  }

  openUpdateModal(content:any, obj:any){
    this.curr_usr = null;
    super.openUpdateModal(content, obj);
    this.loadingRequired = true;
    this.getUsersData().subscribe(x => {
      this.loadingRequired = false;
      if (x !== false) {
        this.listUsers = x;

        this.u_obj['detail'] = this.u_obj['Aprobadores'].map((id: number) => {
          const usuario = this.listUsers.find((u: any) => u.UserId === id);
          return usuario
            ? {
              UserId: usuario.UserId,
              FullName: `${usuario.FirstName} ${usuario.LastName}`
            }
            : {
              UserId: id,
              FullName: 'Usuario no encontrado'
            };
        });


      }
      console.log('Usuarios cargados:', this.u_obj);
      console.log('Usuarios cargados2:', this.u_obj.detail);
    });
  }

  public delUser(obj:any, position:number){
    this.u_obj['detail'].splice(position, 1);
  }

  public markResponsible(obj:any, position:number){
    //debugger;
    let i = 0;
    obj['detail'].forEach(x => {
      //x['labdResponsible'] = false;

      if( i == position ){
        if (x['labdResponsible']==true)
        {
          x['labdResponsible'] = false;
        }
        else{
          x['labdResponsible'] = true;
        }

      }
      i++;
    });
  }

validateCreateInfo(fields:any){
  let mygroup:any = {};
  mygroup = new FormGroup({
      'Name': new FormControl(fields.Name, [Validators.required]),
      'Direction': new FormControl(fields.Direction, []),
      'Description': new FormControl(fields.Description, [])
  });

  return mygroup.valid;
}

public updateItem(content:any, form:any){
  this.isCreating = true;
  var validated = true;
  var qst = this.update_url;

  if( form == undefined ){
    form = {};
  }
  validated = this.validateCreateInfo(form);
  if( !validated ){
    Swal.fire(this.translations['msg_all_required'], '', 'error');
    return;
  }
  // var to:any;

  if( (form.Name == undefined) || (form.Name == '') ){
      Swal.fire('Ingrese todos los campos requeridos', 'msg', 'warning');
      return;
  }

  // Extraer solo los IDs de los aprobadores
  const aprobadoresIds = (this.u_obj.detail || []).map(u => u.UserId);

    var to: any = {
    Name: form.Name,
    Direction: form.Direction,
    Description: form.Description,
    CreatorUserId: form.CreatorUserId,
    LastModifierUserID: this.userinfo['userId'],
    PlantaID: form.PlantaID,
    Aprobadores: aprobadoresIds // <-- aquí agregas los aprobadores correctamente
  };



  this.srv.postCall(qst, to).subscribe(x => {
    this.isCreating = false;
    Swal.close();
    if (x.success) {
      this.reload.next(true);
      this.closeModal('update1');
      Swal.fire('¡Actualizado!', x.msg, 'success');
      this.getList();

    }
 }, err => {
    Swal.close();
    Swal.fire('Error');
   });

}

deleteItem(obj: any){
  var id:any;
  id = {};
  id.PlantaID = obj;
  var qst = this.delete_url;
  this.srv.postCall(qst, id).subscribe(x => {
    this.isCreating = false;
    Swal.close();
    if(x.success){
      this.reload.next(true);
      Swal.fire('Desactivado!', x.msg, 'success');
      this.getList();
  }
  else{
      Swal.fire(x.msg, '', 'error');
  }
 }, err => {
    Swal.close();
    Swal.fire('Error');
   });
}

Activar(obj: any){
  var id:any;
  id = {};
  id.PlantaID = obj;
  var qst = this.active_url;
  this.srv.postCall(qst, id).subscribe(x => {
    this.isCreating = false;
    Swal.close();
    if(x.success){
      this.reload.next(true);
      Swal.fire('¡Activado!', x.msg, 'success');
      this.getList();
  }
  else{
      Swal.fire(x.msg, '', 'error');
  }
 }, err => {
    Swal.close();
    Swal.fire('Error');
   });
}

toggleEditable(event, id) {
  if ( event.target.checked ) {
     this.Activar(id);
 }else {
   this.deleteItem(id);

}
}

  public addUserold(obj:any) {
    console.log('addUser', obj);
    if( this.curr_usr == 0 ){
      return;
    }
    else{
      let usrs = this.listUsers.filter(f => {
        return f.UserId == this.curr_usr;
      });
      let checker = obj['detail'].filter(f => {
        return f.labdUserId == this.curr_usr;
      });

      if((usrs.length > 0) && (checker.length == 0)){
        let usr = usrs[0];
        this.u_obj['detail'].push({labdUserId: usr['UserId'], labdResponsible:false, FullName:usr['FirstName']+' '+usr['LastName']});
      }
    }
  }
}
